import {
  AppBar,
  Box,
  IconButton,
  styled,
  Theme,
  Toolbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import useSettings from "hooks/useSettings";
import { THEMES } from "../../constants";
import { FC } from "react";

type DashboardHeaderProps = {
  setShowSideBar: () => void;
  setShowMobileSideBar: () => void;
};

const DashboardHeaderRoot = styled(AppBar)(({ theme }) => ({
  zIndex: 11,
  boxShadow: "none",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.primary,
}));

const StyledToolBar = styled(Toolbar)(() => ({
  "@media (min-width: 0px)": {
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: 52,
  },
}));

const DashboardHeader: FC<DashboardHeaderProps> = (props) => {
  const { setShowMobileSideBar } = props;
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down(1200));
  const { settings, saveSettings } = useSettings();
  const isDark = settings.theme === THEMES.DARK;

  const toggleTheme = () => {
    saveSettings({ ...settings, theme: isDark ? THEMES.LIGHT : THEMES.DARK });
  };

  return (
    <DashboardHeaderRoot position="sticky">
      <StyledToolBar>
        {downMd && (
          <IconButton
            onClick={setShowMobileSideBar}
            size="small"
            sx={{ mr: 1, ml: -0.5 }}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
        )}

        <Box flexGrow={1} />

        <Tooltip title={isDark ? "Светлая тема" : "Тёмная тема"}>
          <IconButton onClick={toggleTheme} size="small">
            {isDark ? (
              <LightModeRoundedIcon sx={{ fontSize: 18 }} />
            ) : (
              <DarkModeRoundedIcon sx={{ fontSize: 18 }} />
            )}
          </IconButton>
        </Tooltip>
      </StyledToolBar>
    </DashboardHeaderRoot>
  );
};

export default DashboardHeader;
